export const GET_CONTENT_SERIES_START = 'GET_CONTENT_SERIES_START';
export const GET_CONTENT_SERIES_SUCCESS = 'GET_CONTENT_SERIES_SUCCESS';
export const GET_CONTENT_SERIES_ERROR = 'GET_CONTENT_SERIES_ERROR';
